"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * CDK Logo as an SVG component
 */


var CDKLogo = function (_React$Component) {
  _inherits(CDKLogo, _React$Component);

  function CDKLogo() {
    _classCallCheck(this, CDKLogo);

    return _possibleConstructorReturn(this, (CDKLogo.__proto__ || Object.getPrototypeOf(CDKLogo)).apply(this, arguments));
  }

  _createClass(CDKLogo, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          blackFont = _props.blackFont,
          props = _objectWithoutProperties(_props, ["blackFont"]);

      var styles = {
        st0: {
          fill: blackFont ? "#00000" : "#FFFFFF"
        },
        st1: {
          fill: "#84BE41"
        },
        st2: {
          fill: "none",
          stroke: "#FFFFFF",
          strokeWidth: 0.5,
          strokeMiterlimit: 10
        }
      };
      return _react2.default.createElement("svg", _extends({
        version: "1.1",
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 289.3 31",
        style: {
          enableBackground: "new 0 0 289.3 31"
        },
        xmlSpace: "preserve"
      }, props), _react2.default.createElement("title", null, "CDKGlobal_Logo_Reversed_Heavied.6-01-01"), _react2.default.createElement("path", {
        style: styles.st0,
        d: "M124.4,5.2c-1.6-1.1-3.4-1.6-5.3-1.5c-1.5,0-3.1,0.3-4.4,1c-1.2,0.6-2.2,1.5-3,2.6c-0.8,1.1-1.4,2.4-1.8,3.8 c-0.4,1.4-0.6,2.9-0.6,4.4c0,1.6,0.2,3.2,0.6,4.7c0.3,1.4,0.9,2.7,1.8,3.9c0.8,1.1,1.9,2,3.1,2.6c1.4,0.7,2.9,1,4.5,1 c1.2,0,2.3-0.2,3.4-0.6c1-0.4,1.8-1,2.6-1.8c0.7-0.8,1.3-1.7,1.7-2.7c0.4-1.1,0.7-2.2,0.7-3.3h3.9c-0.2,3.2-1.5,6.2-3.8,8.5 c-2.1,2-5.1,3-8.8,3c-2,0-4-0.3-5.9-1.2c-1.6-0.7-3.1-1.8-4.2-3.2c-1.2-1.4-2-3-2.6-4.8c-0.6-1.9-0.9-3.9-0.8-5.9c0-2,0.3-4.1,0.9-6 c0.6-1.8,1.5-3.4,2.6-4.8c1.2-1.4,2.6-2.5,4.3-3.3c1.9-0.8,3.9-1.2,5.9-1.2c1.5,0,2.9,0.2,4.3,0.6c1.3,0.4,2.5,1,3.6,1.9 c1.1,0.8,2,1.8,2.6,3c0.7,1.2,1.2,2.6,1.4,4h-3.9C126.9,7.9,125.9,6.3,124.4,5.2"
      }), _react2.default.createElement("path", {
        style: styles.st0,
        d: "M144.3,26.8c0.5,0,1.1,0,1.6-0.1c0.7-0.1,1.4-0.2,2.1-0.5c0.8-0.3,1.5-0.6,2.2-1.1c0.8-0.5,1.4-1.2,1.9-2 c0.6-1,1.1-2,1.4-3.1c0.4-1.5,0.6-3,0.5-4.6c0-1.6-0.2-3.1-0.5-4.7c-0.3-1.3-0.9-2.5-1.7-3.5c-0.8-1-1.8-1.7-3-2.2 c-1.4-0.5-3-0.8-4.5-0.7h-6.5v22.5H144.3z M144,1c4.5,0,7.9,1.1,10.3,3.4c2.4,2.3,3.6,5.7,3.6,10.4c0,2.2-0.2,4.4-0.8,6.5 c-0.5,1.8-1.3,3.4-2.5,4.8c-1.2,1.3-2.7,2.3-4.4,2.9c-2,0.7-4.1,1.1-6.2,1H134V1L144,1z"
      }), _react2.default.createElement("polygon", {
        style: styles.st0,
        points: "164.6,1.1 164.6,15.5 179.3,1.1 184.3,1.1 172.1,12.7 184.8,30 179.9,30 169.4,15.4 164.6,19.9 164.6,30 160.7,30 160.7,1.1 "
      }), _react2.default.createElement("path", {
        style: styles.st0,
        d: "M197,15.5v2.2h10.6c0.1,1.5-0.1,3-0.6,4.4c-0.4,1.3-1.2,2.6-2.1,3.6c-1,1-2.1,1.8-3.4,2.3 c-1.4,0.6-3,0.9-4.5,0.8c-1.8,0-3.5-0.3-5.1-1c-1.4-0.7-2.6-1.6-3.6-2.8c-1-1.2-1.7-2.7-2.1-4.2c-0.5-1.7-0.7-3.4-0.7-5.1 c0-1.7,0.2-3.5,0.8-5.1c0.5-1.6,1.2-3,2.2-4.3c2.1-2.7,5.3-4.2,8.6-4.1c2.3-0.1,4.6,0.7,6.5,2.1c1.8,1.5,3,3.5,3.5,5.8l0.1,0.2h2.2 l0-0.3c-0.2-1.5-0.7-2.9-1.5-4.2c-0.7-1.2-1.7-2.3-2.8-3.1c-1.1-0.9-2.4-1.6-3.7-2c-1.4-0.4-2.9-0.7-4.3-0.7c-2.1,0-4.1,0.4-6,1.3 c-1.7,0.8-3.2,2-4.4,3.4c-1.2,1.5-2.1,3.2-2.7,5c-0.6,1.9-1,3.9-0.9,5.9c0,2,0.3,4.1,0.9,6c0.6,1.8,1.5,3.4,2.7,4.9 c1.2,1.4,2.7,2.5,4.4,3.3c1.9,0.8,3.9,1.2,5.9,1.2c1.3,0,2.5-0.2,3.8-0.5c1.2-0.3,2.3-0.8,3.3-1.4c1-0.6,1.8-1.3,2.6-2.2 c0.4-0.5,0.8-1.1,1.1-1.8v5.2h2.1V15.5H197z"
      }), _react2.default.createElement("polygon", {
        style: styles.st0,
        points: "212.2,0.8 212.2,30.3 214.3,30.3 214.4,0.8 "
      }), _react2.default.createElement("path", {
        style: styles.st0,
        d: "M235.5,15.3c-0.4-1.3-1-2.5-1.9-3.6c-0.8-1-1.9-1.9-3.1-2.5c-2.7-1.2-5.8-1.2-8.5,0c-1.2,0.6-2.3,1.4-3.1,2.5 c-0.9,1-1.5,2.2-1.9,3.5c-0.8,2.8-0.8,5.8,0,8.6c0.4,1.3,1.1,2.5,1.9,3.6c0.8,1,1.9,1.8,3.1,2.4c1.3,0.6,2.8,0.9,4.2,0.9 c1.5,0,2.9-0.2,4.2-0.9c1.2-0.6,2.3-1.4,3.1-2.4c0.9-1.1,1.5-2.3,1.9-3.6c0.4-1.4,0.7-2.8,0.6-4.3C236.1,18.2,235.9,16.7,235.5,15.3 z M233.4,23.1c-0.3,1.1-0.8,2.1-1.5,3c-0.7,0.8-1.5,1.5-2.4,2c-2.1,1-4.5,1-6.6,0c-0.9-0.5-1.8-1.2-2.4-2c-0.7-0.9-1.2-1.9-1.5-3 c-0.7-2.3-0.7-4.7,0-7c0.3-1.1,0.8-2.1,1.5-3c1.3-1.8,3.5-2.8,5.7-2.8c1.1,0,2.3,0.3,3.3,0.8c0.9,0.5,1.8,1.2,2.4,2 c0.7,0.9,1.2,1.9,1.5,3C234.1,18.4,234.1,20.8,233.4,23.1z"
      }), _react2.default.createElement("path", {
        style: styles.st0,
        d: "M256.4,14.9c-0.4-1.2-1-2.4-1.8-3.4c-0.8-1-1.8-1.8-2.9-2.3c-1.3-0.6-2.7-0.9-4.1-0.8c-0.9,0-1.7,0.1-2.6,0.3 c-0.8,0.2-1.6,0.6-2.3,1c-0.7,0.4-1.4,1-1.9,1.6c-0.3,0.3-0.6,0.7-0.8,1.1V0.8h-2.1v29.5h2.1v-3.8c0.1,0.1,0.1,0.2,0.1,0.2 c0.4,0.6,0.9,1.2,1.5,1.8c0.7,0.7,1.6,1.2,2.5,1.6c1.2,0.5,2.4,0.7,3.6,0.7c0.9,0,1.8-0.2,2.7-0.4c1.2-0.3,2.2-0.8,3.1-1.6 c1.1-1,2-2.2,2.6-3.6c0.8-1.9,1.1-4,1-6.1C256.9,17.6,256.7,16.2,256.4,14.9z M254.8,19.1c0,1.2-0.1,2.4-0.4,3.5 c-0.2,1.1-0.7,2.2-1.3,3.2c-0.6,0.9-1.3,1.7-2.2,2.2c-1,0.6-2.2,0.9-3.3,0.8c-2.3,0.1-4.6-1-5.9-3c-0.6-1-1.1-2-1.4-3.1 c-0.3-1.2-0.4-2.4-0.4-3.7c0-1.2,0.1-2.4,0.5-3.5c0.3-1,0.8-2,1.4-2.8c0.6-0.8,1.4-1.4,2.3-1.8c1.1-0.5,2.2-0.7,3.4-0.7h0 c1.1-0.1,2.2,0.2,3.1,0.7c0.9,0.5,1.7,1.2,2.3,2c0.6,0.8,1.1,1.8,1.4,2.8C254.6,16.9,254.8,18,254.8,19.1z"
      }), _react2.default.createElement("path", {
        style: styles.st0,
        d: "M277,28.2c-1.1,0.2-1.5,0.2-1.7,0c-0.2-0.1-0.3-0.3-0.3-0.5c-0.1-0.2-0.1-0.5-0.1-0.7v-13 c0-1.6-0.6-3.1-1.8-4.1c-1.2-1-3.1-1.5-5.7-1.5c-2.1-0.1-4.3,0.5-6,1.8c-1.5,1.4-2.4,3.3-2.3,5.4v0.3h2.2v-0.3c0-1.5,0.6-3,1.8-4 c1.2-0.9,2.8-1.4,4.3-1.3c0.9,0,1.7,0.1,2.6,0.3c0.6,0.2,1.2,0.5,1.7,0.8c0.4,0.3,0.7,0.7,0.9,1.2c0.2,0.5,0.3,1,0.3,1.5 c0,0.6,0,1.2-0.1,1.8c0,0.4-0.2,0.7-0.5,1c-0.4,0.3-0.8,0.6-1.3,0.7c-0.8,0.2-1.7,0.3-2.6,0.4l-2.4,0.2c-0.9,0.1-1.8,0.2-2.7,0.4 c-0.9,0.2-1.8,0.5-2.6,1c-0.8,0.5-1.5,1.1-1.9,1.9c-0.6,1-0.8,2-0.8,3.1c-0.1,1.8,0.6,3.5,1.9,4.7c1.6,1.1,3.4,1.6,5.3,1.5 c1,0,1.9-0.1,2.8-0.4c0.8-0.2,1.6-0.6,2.3-1c0.7-0.4,1.2-0.9,1.8-1.5c0.2-0.3,0.4-0.6,0.6-0.8c0,0.4,0,0.8,0.1,1.2 c0.1,0.4,0.2,0.8,0.4,1.1c0.2,0.3,0.6,0.6,1,0.7c0.5,0.2,1.1,0.3,1.6,0.3c0.5,0,0.9-0.1,1.3-0.2l0.2-0.1v-1.9L277,28.2z M272.8,18.8 l-0.1,3.2c0,0.5-0.1,1-0.2,1.5c-0.2,0.8-0.5,1.6-1,2.3c-0.6,0.9-1.4,1.6-2.3,2.1c-1.2,0.7-2.6,1-4,0.9c-1.4,0.1-2.7-0.3-3.8-1.1 c-0.9-0.8-1.4-2-1.3-3.2c0-0.8,0.1-1.5,0.5-2.2c0.3-0.6,0.8-1,1.4-1.3c0.6-0.3,1.3-0.6,2-0.7c0.7-0.1,1.5-0.3,2.2-0.3l2.6-0.2 c0.9-0.1,1.7-0.2,2.6-0.4C271.9,19.3,272.4,19.1,272.8,18.8z"
      }), _react2.default.createElement("rect", {
        x: "279.1",
        y: "0.8",
        style: styles.st0,
        width: "2.1",
        height: "29.5"
      }), _react2.default.createElement("path", {
        style: styles.st0,
        d: "M15.2,0.4c8.4,0,15.2,6.8,15.1,15.2s-6.8,15.2-15.2,15.1C6.8,30.7,0,23.9,0,15.5C0,7.1,6.8,0.4,15.2,0.4"
      }), _react2.default.createElement("path", {
        style: styles.st0,
        d: "M48.9,0.4C57.2,0.4,64,7.1,64,15.5s-6.8,15.2-15.2,15.2s-15.2-6.8-15.2-15.2l0,0C33.7,7.1,40.5,0.4,48.9,0.4"
      }), _react2.default.createElement("path", {
        style: styles.st1,
        d: "M67.4,15.5c0,8.4,6.8,15.2,15.2,15.2c8.4,0,15.2-6.8,15.2-15.2S91,0.4,82.6,0.4c0,0,0,0,0,0 C74.2,0.4,67.4,7.1,67.4,15.5L67.4,15.5"
      }), _react2.default.createElement("path", {
        style: styles.st0,
        d: "M284.9,28.8h0.6v-1.4h0.4l0.8,1.4h0.7l-0.9-1.4c0.4,0,0.8-0.3,0.9-0.8c0,0,0-0.1,0-0.1c0-0.7-0.5-1-1.3-1h-1.2 L284.9,28.8z M285.6,26.1h0.5c0.3,0,0.7,0,0.7,0.4s-0.3,0.5-0.6,0.5h-0.6V26.1z"
      }), _react2.default.createElement("circle", {
        style: styles.st2,
        cx: 286,
        cy: "27.2",
        r: 3
      }));
    }
  }]);

  return CDKLogo;
}(_react2.default.Component);

CDKLogo.propTypes = {
  /** Set to `true` to turn CDKGlobal to black font. */
  blackFont: _propTypes.bool
};
exports.default = CDKLogo;